import FinancialEntryHTML from "../FinancialEntry/FinancialEntryHTML";
export default function IncomeHTML() {
  return <FinancialEntryHTML Type="Income" />;
}
